export function registerSW() {
    if (!("serviceWorker" in navigator))
        return;
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/sw.js").catch((err) => {
            console.warn("[pwa] SW registration failed", err);
        });
    });
}
